import * as React from "react";
import { useCallback } from "react";
import useAssistantSidebar from "ai/sidebar/useAssistantSidebar";
import useWidgetResults from "views/components/useWidgetResults";
import useView from "views/hooks/useView";
import createWidgetSummaryRequest, { AGGREGATION_WIDGET_TYPE } from "ai/widget-summary/createWidgetSummaryRequest";
import WidgetSummaryButton from "ai/widget-summary/WidgetSummaryButton";
const WidgetSummaryActionComponent = ({ widget }) => {
  var _a, _b;
  const { openWidgetSummary } = useAssistantSidebar();
  const { widgetData: widgetResult } = useWidgetResults(widget.id);
  const view = useView();
  const onClick = useCallback(
    () => openWidgetSummary(createWidgetSummaryRequest(view, widget, widgetResult)),
    [openWidgetSummary, view, widget, widgetResult]
  );
  return /* @__PURE__ */ React.createElement(
    WidgetSummaryButton,
    {
      widgetType: AGGREGATION_WIDGET_TYPE,
      widgetEmpty: !!((_a = widget == null ? void 0 : widget.config) == null ? void 0 : _a.isEmpty),
      noData: ((_b = widgetResult == null ? void 0 : widgetResult.chart) == null ? void 0 : _b.total) === 0,
      onClick
    }
  );
};
export default WidgetSummaryActionComponent;
